'use client';
import CategoryFaqItem from './CategoryFaqItem';

const CategoryFaq = props => {
  const { faqs } = props;

  return (
    <div>
      {faqs.map(data => {
        return (
          <CategoryFaqItem
            key={data.id}
            id={data.id}
            question={data.question}
            answer={data.answer}
          />
        );
      })}
    </div>
  );
};

export default CategoryFaq;
